/**
 * Header「我的票券」入口 v5
 * - 未讀「明天有課」→ badge 驚嘆號 + ?lb_remind=1
 * - 否則 → 當日未用張數（含 0）
 * - 已讀 batch：localStorage lb_ticket_remind_ack_v1
 */
(function () {
  if (window.__lbHeaderMyTicketsNavV5) return;
  window.__lbHeaderMyTicketsNavV5 = true;

  var HREF = '/pages/我的活動票券-v2';
  var LABEL = '我的票券';
  var LIST_PATH = '/apps/ladybae-vendor-test/customer-tickets/list';
  var FETCH_LIMIT = 200;
  var ACK_KEY = 'lb_ticket_remind_ack_v1';
  try {
    localStorage.removeItem('lb_ticket_remind_demo');
    sessionStorage.removeItem('lb_ticket_remind_demo');
  } catch (eDemoClear) { /* ignore */ }

  var TICKET_SVG =
    '<svg class="lb-tickets-icon-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false" fill="none">' +
      '<path stroke="currentColor" stroke-width="1.65" stroke-linecap="round" stroke-linejoin="round" d="M4 6.75c0-.97.78-1.75 1.75-1.75H16.5c.97 0 1.75.78 1.75 1.75v1.2a1.75 1.75 0 1 1 0 3.5v1.1a1.75 1.75 0 1 1 0 3.5v1.2c0 .97-.78 1.75-1.75 1.75H5.75C4.78 18.25 4 17.47 4 16.5v-1.2a1.75 1.75 0 1 1 0-3.5v-1.1a1.75 1.75 0 1 1 0-3.5V6.75Z"/>' +
      '<path stroke="currentColor" stroke-width="1.65" stroke-linecap="round" d="M9.25 5.75v12.5"/>' +
      '<path stroke="currentColor" stroke-width="1.65" stroke-linecap="round" d="M12.5 9.5h3.25M12.5 12h2.25M12.5 14.5h3.25"/>' +
    '</svg>';

  function isTicketsHref(href) {
    if (!href) return false;
    try {
      var u = String(href);
      return u.indexOf('我的活動票券') !== -1 || decodeURIComponent(u).indexOf('我的活動票券') !== -1;
    } catch (e) {
      return String(href).indexOf('ticket') !== -1 && String(href).indexOf('pages') !== -1;
    }
  }

  function parseDate(v) {
    if (!v) return null;
    var d = new Date(String(v));
    return Number.isNaN(d.getTime()) ? null : d;
  }

  function pad2(n) {
    n = Number(n) || 0;
    return (n < 10 ? '0' : '') + n;
  }

  function ymdTPE(dateObj) {
    var d = dateObj instanceof Date ? dateObj : new Date(dateObj);
    if (Number.isNaN(d.getTime())) return '';
    var parts = new Intl.DateTimeFormat('zh-TW', {
      timeZone: 'Asia/Taipei',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).formatToParts(d);
    var m = {};
    parts.forEach(function (p) { m[p.type] = p.value; });
    return (m.year || '') + '-' + (m.month || '') + '-' + (m.day || '');
  }

  function addYmd(ymd, delta) {
    if (!ymd || ymd.length < 10) return '';
    var y = Number(ymd.slice(0, 4));
    var mo = Number(ymd.slice(5, 7));
    var day = Number(ymd.slice(8, 10));
    if (!y || !mo || !day) return '';
    var utc = Date.UTC(y, mo - 1, day + (Number(delta) || 0));
    var x = new Date(utc);
    return x.getUTCFullYear() + '-' + pad2(x.getUTCMonth() + 1) + '-' + pad2(x.getUTCDate());
  }

  function ticketYmd(t) {
    var start = parseDate(t && (t.event_start_at || t.start_at));
    return start ? ymdTPE(start) : '';
  }

  function ticketUid(t) {
    return String((t && (t.ticket_uid || t.qr_payload)) || '').trim();
  }

  /** 當日未用：與 v3 可用性一致（不含待確認） */
  function isUsableTicket(t) {
    var label = String(t.state_label || '').trim();
    var raw = String(t.state || t.ticket_status || t.status || '').toUpperCase();
    var awaits =
      t.awaits_vendor_payment_confirm === true ||
      raw === 'PENDING_VENDOR_CONFIRM' ||
      String(t.state || '').toLowerCase() === 'pending_vendor';

    if (t.redeemed || t.redeemed_at || /已使用/.test(label)) return false;
    if (raw === 'VOID' || raw === 'VOIDED' || raw === 'CANCELLED' || raw === 'REFUNDED' || /取消|作廢|VOID|已取消/.test(label)) {
      return false;
    }
    if (awaits || /待廠商確認|待確認收款/.test(label)) return false;
    if (raw === 'EXPIRED' || String(t.state || '').toLowerCase() === 'expired' || /已過期/.test(label)) {
      return false;
    }
    var end = parseDate(t.event_end_at || t.end_at) || parseDate(t.event_start_at || t.start_at);
    if (end && end.getTime() < Date.now()) return false;
    if (t.qr_usable === false) return false;
    return true;
  }

  /** 明天提醒名單：可用 + 待確認；排除已用／取消／過期 */
  function isRemindableTicket(t) {
    var label = String(t.state_label || '').trim();
    var raw = String(t.state || t.ticket_status || t.status || '').toUpperCase();
    if (t.redeemed || t.redeemed_at || /已使用/.test(label)) return false;
    if (raw === 'VOID' || raw === 'VOIDED' || raw === 'CANCELLED' || raw === 'REFUNDED' || /取消|作廢|VOID|已取消/.test(label)) {
      return false;
    }
    if (raw === 'EXPIRED' || String(t.state || '').toLowerCase() === 'expired' || /已過期/.test(label)) {
      return false;
    }
    var end = parseDate(t.event_end_at || t.end_at) || parseDate(t.event_start_at || t.start_at);
    if (end && end.getTime() < Date.now()) return false;
    return true;
  }

  function readAck() {
    try {
      var raw = localStorage.getItem(ACK_KEY);
      if (!raw) return null;
      var j = JSON.parse(raw);
      if (!j || typeof j !== 'object') return null;
      return j;
    } catch (e) {
      return null;
    }
  }

  function isBatchAcked(batchKey) {
    if (!batchKey) return false;
    var ack = readAck();
    return !!(ack && ack.batchKey === batchKey);
  }

  function buildBatchKey(tomorrowYmd, tickets) {
    var uids = tickets.map(ticketUid).filter(Boolean).sort();
    return tomorrowYmd + '|' + uids.join(',');
  }

  function analyzeTickets(items) {
    var today = ymdTPE(new Date());
    var tomorrow = addYmd(today, 1);
    var tomorrowTickets = [];
    var todayUsable = 0;
    for (var i = 0; i < items.length; i++) {
      var t = items[i];
      var ymd = ticketYmd(t);
      if (ymd === today && isUsableTicket(t)) todayUsable += 1;
      if (ymd === tomorrow && isRemindableTicket(t)) tomorrowTickets.push(t);
    }
    var batchKey = tomorrowTickets.length ? buildBatchKey(tomorrow, tomorrowTickets) : '';
    var unreadRemind = tomorrowTickets.length > 0 && !isBatchAcked(batchKey);
    return {
      todayUsable: todayUsable,
      tomorrowTickets: tomorrowTickets,
      batchKey: batchKey,
      unreadRemind: unreadRemind,
    };
  }

  function removeMenubarTicketLinks() {
    var nodes = document.querySelectorAll(
      '#nav ul[data-type="main-nav"] > li, #nav > ul[data-type="top-nav"] > li'
    );
    Array.prototype.forEach.call(nodes, function (li) {
      if (li.getAttribute('data-lb-my-tickets') === '1') {
        li.remove();
        return;
      }
      var a = li.querySelector(':scope > a');
      if (!a) return;
      var text = (a.textContent || '').replace(/\s+/g, '');
      if (isTicketsHref(a.getAttribute('href')) || text === '我的票券' || text.indexOf('我的票券') === 0) {
        li.setAttribute('data-lb-my-tickets-menubar-hide', '1');
      }
    });
  }

  function ensureHeaderIcon() {
    var ul = document.querySelector('#nav-user ul[data-type="user-nav"]');
    if (!ul) return null;

    var item = ul.querySelector('li[data-lb-my-tickets-icon="1"]');
    if (!item) {
      item = document.createElement('li');
      item.setAttribute('data-lb-my-tickets-icon', '1');
      /* 插在購物袋前：帳號 → 票券 → 購物袋 */
      var before =
        ul.querySelector('li.cart') ||
        ul.querySelector('li.wishlist-header') ||
        ul.querySelector('li.user-login');
      if (before) ul.insertBefore(item, before);
      else ul.appendChild(item);
    }

    item.classList.remove('mobile-only', 'hidden');

    var a = item.querySelector('a');
    if (!a) {
      a = document.createElement('a');
      item.appendChild(a);
    }

    a.href = HREF;
    a.removeAttribute('role');
    a.style.pointerEvents = '';
    a.setAttribute('aria-label', LABEL);
    a.classList.add('lb-header-my-tickets-icon');

    /* 已由 early 腳本建好就不要重寫 innerHTML，避免 icon 閃爍 */
    var badge = a.querySelector('[data-lb-tickets-count]');
    var wrap = a.querySelector('.lb-tickets-icon-wrap');
    if (!badge || !wrap) {
      a.innerHTML =
        '<span class="lb-tickets-icon-wrap" aria-hidden="true">' + TICKET_SVG + '</span>' +
        '<span class="lb-tickets-count" data-lb-tickets-count data-count="0">0</span>' +
        '<span class="hidden">' + LABEL + '</span>';
      badge = a.querySelector('[data-lb-tickets-count]');
    }

    return {
      link: a,
      badge: badge,
    };
  }

  function setCountBadge(badgeEl, linkEl, count) {
    if (!badgeEl) return;
    var n = Math.max(0, Number(count) || 0);
    badgeEl.textContent = n > 99 ? '99+' : String(n);
    badgeEl.classList.remove('is-remind');
    badgeEl.removeAttribute('hidden');
    badgeEl.setAttribute('data-count', String(n));
    if (linkEl) {
      linkEl.href = HREF;
      linkEl.setAttribute('aria-label', LABEL + '，今日未使用 ' + n + ' 張');
    }
  }

  function setRemindBadge(badgeEl, linkEl) {
    if (!badgeEl) return;
    badgeEl.textContent = '!';
    badgeEl.classList.add('is-remind');
    badgeEl.removeAttribute('hidden');
    badgeEl.setAttribute('data-count', 'remind');
    if (linkEl) {
      linkEl.href = HREF + (HREF.indexOf('?') >= 0 ? '&' : '?') + 'lb_remind=1';
      linkEl.setAttribute('aria-label', LABEL + '，明天有課');
    }
  }

  function fetchTickets() {
    var params = new URLSearchParams();
    params.set('page', '1');
    params.set('limit', String(FETCH_LIMIT));
    return fetch(LIST_PATH + '?' + params.toString(), {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    }).then(function (response) {
      return response.json().then(function (payload) {
        if (!response.ok || !payload || payload.ok !== true) {
          throw new Error('tickets_list_failed');
        }
        return Array.isArray(payload.data) ? payload.data : [];
      });
    });
  }

  function hideDuplicateTopNavSlot() {
    var topNav = document.querySelector('#nav > ul[data-type="top-nav"]');
    if (topNav) topNav.setAttribute('data-lb-my-tickets-hide', '1');
  }

  function applyState(ui, analysis) {
    if (!ui) return;
    if (analysis.unreadRemind) setRemindBadge(ui.badge, ui.link);
    else setCountBadge(ui.badge, ui.link, analysis.todayUsable);
  }

  var lastUi = null;

  function refreshBadge() {
    var ui = lastUi || ensureHeaderIcon();
    lastUi = ui;
    if (!ui) return Promise.resolve();
    return fetchTickets()
      .then(function (items) {
        applyState(ui, analyzeTickets(items));
      })
      .catch(function () {
        setCountBadge(ui.badge, ui.link, 0);
      });
  }

  function run() {
    removeMenubarTicketLinks();
    lastUi = ensureHeaderIcon();
    hideDuplicateTopNavSlot();
    /* 先顯示 0 與購物袋對齊，再依 API 更新 */
    if (lastUi) setCountBadge(lastUi.badge, lastUi.link, 0);
    refreshBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();

/* ticket-remind-v5 20260727T175000Z show-zero-balance */
